import { CodedProperty } from "sprint-common-web";

import { AirlineLookupResponse } from "../api/admin-api/GetAirlinesLookupResponse";

export type Airline = CodedProperty;

export const mapToAirline = (response: AirlineLookupResponse): Airline => ({
    id: response.id,
    name: response.name,
    code: response.code
});
